<ui-icon
  (click)="slide.emit(-1)"
  [hidden]="current === 0"
  class="left"
  faName="chevron-left"
  faStyle="light"
></ui-icon>

<ui-icon
  (click)="slide.emit(1)"
  [hidden]="current === max"
  class="right"
  faName="chevron-right"
  faStyle="light"
></ui-icon>
